/**
 * @fileoverview PATCH handler for the "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersShopifyAppGroupIdBridgesBridgeIdCacheKeys } from "./constants";
import type { PatchAlloysPartnersShopifyAppGroupIdBridgesBridgeIdProps } from "./types";

export const patchAlloysPartnersShopifyAppGroupIdBridgesBridgeId = reactQueryMutationAdapter(
  alloysPartnersShopifyAppGroupIdBridgesBridgeIdCacheKeys,
  ({
    appGroupId,
    bridgeId,
    enabledUserEvents,
    externalIdType,
    customIdEndpoint,
    enabledInBrowserMessaging,
    emailOptIn,
    additionalEmailSubscriptionGroupIds,
    smsOptIn,
    smsSubscriptionGroup,
    defaultEmailSubscriptionGroupName,
    historicalBackfillOptIn,
    directIntegrationSelected,
    thirdPartyTagManager,
    userTrackingBehavior,
    catalogOptIn,
    catalogItemIdType,
    catalogIncludeOnlyActiveProducts,
    syncProductTags,
    selectedProductTags,
    syncProductMetafields,
    selectedProductMetafields,
    syncProductCollections,
    selectedCollectionIds,
    selectedCollections,
    selectedMarkets,
  }: PatchAlloysPartnersShopifyAppGroupIdBridgesBridgeIdProps): Promise<any> => {
    return fetch(
      `/alloys/partners/shopify/${appGroupId}/bridges/${bridgeId}`,
      "PATCH",
      {
        enabled_user_events: enabledUserEvents,
        external_id_type: externalIdType,
        custom_id_endpoint: customIdEndpoint,
        enabled_in_browser_messaging: enabledInBrowserMessaging,
        email_opt_in: emailOptIn,
        additional_email_subscription_group_ids: additionalEmailSubscriptionGroupIds,
        sms_opt_in: smsOptIn,
        sms_subscription_group: smsSubscriptionGroup,
        default_email_subscription_group_name: defaultEmailSubscriptionGroupName,
        historical_backfill_opt_in: historicalBackfillOptIn,
        direct_integration_selected: directIntegrationSelected,
        third_party_tag_manager: thirdPartyTagManager,
        user_tracking_behavior: userTrackingBehavior,
        catalog_opt_in: catalogOptIn,
        catalog_item_id_type: catalogItemIdType,
        catalog_include_only_active_products: catalogIncludeOnlyActiveProducts,
        sync_product_tags: syncProductTags,
        selected_product_tags: selectedProductTags,
        sync_product_metafields: syncProductMetafields,
        selected_product_metafields: selectedProductMetafields,
        sync_product_collections: syncProductCollections,
        selected_collection_ids: selectedCollectionIds,
        selected_collections: selectedCollections,
        selected_markets: selectedMarkets,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
